// tslint:disable: completed-docs

/**
 * Stores for the APP
 */
export const SAILS_APP_NAME = 'GIGAKOMBI_LP';
/**
 * Stores for the Container
 */
export const CONTAINER_STORAGE = 'STORAGE';

/**
 * Session Storage Item
 */
export const SAILS_GK_LP_STORAGE = 'SAILS_GKLP';

/**
 * CMS Options entered in CMS
 */
export const ADDITIONAL_CMS_OPTIONS_FROM_DOM = (<any>window).additionalPageOptions;

/**
 * Container ID for static HTML content (Additional content container)
 */
export const ADDITIONAL_CONTENT_CONTAINER = 'additional-content-container';

/**
 * PATH für benefit puzzle icons
 */
export const BENEFIT_PUZZLE_ICON_PATH = '//eweb8.vfd2-testnet.de/media/img/icons/mid-render/';

/**
 * URL Parameter for preselcting an offer
 */
export const PARAM_OFFER_ID = 'offerId';

/**
 * Container-Ids and Classnames for selectors
 */

export const GIGAKOMBI_LANDINGPAGE_CONTAINER = 'gigakombi-landingpage__container';

// DIV to display error in CMS preview
export const OFFER_EDITOR_INFORMATION_CONTAINER = 'offer-error-editor-information';

// Container with static content to be displayed in case of json error
export const GIGAKOMBI_ERROR_CASE_WRAPPER = 'gigakombi_error_case_wrapper';

// Loading Spinner
export const LOADING_INDICATOR_CONTAINER = 'brix-loadingspinner-container';
export const LOADING_INDICATOR_IMAGE_CONTAINER = 'brix-loading-spinner__spinner';

// Multi-Picker
export const MULTI_PICKER_HAS_CONTAINER = 'brix-multi-picker-has-container';
export const MULTI_PICKER_WANTS_CONTAINER = 'brix-multi-picker-wants-container';

/* dev-only-code:start */
// Constants used in Unit Tests
export const MULTI_PICKER_HAS_ID = '791994';
export const MULTI_PICKER_WANTS_ID = '792338';

export const MULTI_PICKER_ITEM_HAS_MOBILFUNK_ID = '791995';
export const MULTI_PICKER_ITEM_HAS_INTERNET_ID = '792302';
export const MULTI_PICKER_ITEM_HAS_TV_ID = '792304';
export const MULTI_PICKER_ITEM_HAS_NONE_ID = '792303';
export const MULTI_PICKER_ITEM_WANTS_MOBILFUNK_ID = '792339';
export const MULTI_PICKER_ITEM_WANTS_INTERNET_ID = '792340';
export const MULTI_PICKER_ITEM_WANTS_TV_ID = '792341';
export const MULTI_PICKER_ITEM_WANTS_REDPLUS_ID = '792342';
/* dev-only-code:end */

// Accordion
export const ACCORDION_CONTAINER = 'accordion-static2';
export const ACCORDION_ITEM = 'brix-accordion-item';

// Notification default offer
export const DEFAULT_NOTIFICATION_CONTAINER = 'brix-default-notification';

// "Zeige mir das Angebot"
export const BUTTON_SELECT_OFFER_CONTAINER = 'brix_button_selct-offer-container';

// Offer-Container (all Offers)
export const OFFER_DISPLAY_CONTAINER = 'offer-display-container';

// Multi-Divider
export const MULTI_DIVIDER_MAX_ITEMS = 4;

// Offer-Price
export const OFFER_PRICE_CONTAINER = 'offer-price';

// Hotline Link in Notification
export const NOTIFICATION_HOTLINE_LINK_ID = 'notification_hotline_link';

export const ALL_JSON_KEYS = [
    'ID',
    'Angebot_1',
    'Bundle_Name',
    'Multi_Divider_Headline',
    'MD_Icon_Text_1',
    'MD_Icon_1',
    'MD_Icon_Text_2',
    'MD_Icon_2',
    'MD_Icon_Text_3',
    'MD_Icon_3',
    'MD_Icon_Text_4',
    'MD_Icon_4',
    'Bundle_Benefit_1',
    'Bundle_Benefit_2',
    'Bundle_Benefit_3',
    'Card_Headline',
    'Badge',
    'Badge_FN',
    'Price_FN',
    'Total_Discount_Label',
    'Total_Discount',
    'Discount_Onetime_Label',
    'Discount_Onetime',
    'Total_Onetime_wDiscount_Label',
    'Total_Onetime_wDiscount',
    'Total_wDiscount_BigPrice',
    'Total_Subline_1',
    'Total_Subline_2',
    'Total_Subline_3',
    'Total_Subline_4',
    'Mobile_Product',
    'Mobile_Product_Detail',
    'Mobile_Benefit',
    'Mobile_FN',
    'Mobile_BigPrice',
    'Mobile_Monthly_Subline',
    'Mobile_Onetime',
    'Mobile_Onetime_Subline',
    'Fixed_Product',
    'Fixed_Product_Detail',
    'Fixed_Benefit',
    'Fixed_FN',
    'Fixed_BigPrice',
    'Fixed_Monthly_Subline',
    'Fixed_Onetime',
    'Fixed_Onetime_Subline',
    'TV_Product',
    'TV_Product_Detail',
    'TV_Benefit',
    'TV_FN',
    'TV_BigPrice',
    'TV_Monthly_Subline',
    'TV_Onetime',
    'TV_Onetime_Subline',
    'RedPlus_Product',
    'RedPlus_Product_Detail',
    'RedPlus_Benefit',
    'RedPlus_FN',
    'RedPlus_BigPrice',
    'RedPlus_Monthly_Subline',
    'RedPlus_Onetime',
    'RedPlus_Onetime_Subline',
    'CTA_Label',
    'CTA_Link_Tariff',
    'CTA_Link_Generic',
    'Angebot_2',
    'Additional_Contents',
];

/**
 * Container ID Accordion with general GK Information
 */
export const CONTAINER_ACCORDION_GIGAKOMBI_GENERAL_INFO = 'infos-gigakombi';

/**
 * Container ID Accordion with benefit GK Information
 */
export const CONTAINER_ACCORDION_GIGAKOMBI_BENEFITS_INFO = 'infos-gigakombi-benefits';

/**
 * Classname for Accordion Item Label
 */
export const BRIX_ACCORDION_ITEM_LABEL = 'brix-accordion-item__label';
/**
 * Serever path to the jsons
 */
export const JSON_FILE_PATH = '/api-static/gigakombi/';
/**
 * Query param name
 */
export const JSON_FILE_PARAM_NAME = 'jsonFile';
/**
 * AdobeTargeting object name
 */
export const ADOBE_TARGETING_OBJ_NAME = 'AdobeTargeting';

/**
 * Offer card wrapper elements CSS class
 */
export const OFFER_CARD_WRAPPER = 'offer-card-wrapper';

/**
 * TRIGGERNEXTOVERLAY
 */
export const TRIGGERNEXTOVERLAY = 'APP/TRIGGERNEXTOVERLAY';

/**
 * TOGGLE_OVERLAY
 */
export const TOGGLE_OVERLAY = 'APP/TOGGLE_OVERLAY';
